import { Modal } from "./modal";
import { Ajax } from "../ajax";


// *************************************************************************
// Třída s modálním dialogem, který má obsah se kterým budeme programově pracovat
// (jinak nám stačí "obyčejná" třída Modal).
//
// ModalDialog není předáván do veřejného namespace (není to zatím potřeba).
// *************************************************************************

//
// Třída ModalDialog dědí od třídy Modal.
//
export function ModalDialog(element) {
	Modal.call(this, element);
	this.content = this.element.querySelector(".modal-content");
}
ModalDialog.prototype = Object.create(Modal.prototype);
ModalDialog.prototype.constructor = ModalDialog;

//
// innerHTML - která nastavuje obsah dialogu - chceme mít jako property, nikoliv jako metodu. Proč?
// Jenom kvůli konzistenci se standardní property innerHTML na HTML elementu.
//
Object.defineProperty(ModalDialog.prototype, "innerHTML", {
	set: function(html) {
		this.content.innerHTML = html;
	}
});



//
// Vytvoří modální dialog i s obsahem.
//
ModalDialog.create = function() {
	var modal = Modal.create();

	// Obyčejný modální dialog obohatíme o obsah.
	modal.innerHTML = "<div class='modal-dialog'><div class='modal-content'></div></div>";

	return modal;
}


//
// Vytvoří nebo vrátí existující instanci modálního dialogu.
//
ModalDialog.get = function(element) {
	return Modal.get(element, ModalDialog);
}

//
// Vytvoří modální okno z AJAXového požadavku na danou url.
// V současné době se pouze GETem zavolá daná URL, nic dalšího "složitého".
// Při čekání zobrazí spinner, aby uživatel měl povědomí o tom, že se něco děje.
// Ajaxová odpověď může obsahovat speciální HTTP hlavičku "Ajax-Modal-Class" s libovolnými CSS třídami,
// které se přidají k modálnímu oknu (např. třídu "modal-lg" pro větší modální okno).
//
ModalDialog.openAjax = function(url) {
	// Připravíme si modální okno.
	var modal = ModalDialog.get();

	// Zobrazíme spinner.
	modal.element.classList.add("sending-request");
	modal.open();

	// Nejprve načteme data
	Ajax.get(url, { "Ajax-Modal-Requested-With": "ModalDialog" }).then(function(data) {
		let event = data.event;
		let xhr = data.xhr;

		modal.element.classList.remove("sending-request");
		modal.innerHTML = event.target.response;

		// Modální okno může mít nějaké své speciální třídy. Získáme je z vlastní speciální HTTP hlavičky
		// Ajax-Modal-Class, kterou bylo možné při odesílání požadavku ze serveru nastavit.
		var modalClass = xhr.getResponseHeader("Ajax-Modal-Class");
		if (modalClass) {
			modal.element.setAttribute("class", modal.element.getAttribute("class") + " " + modalClass);
		}

		var modalFeature = xhr.getResponseHeader("Ajax-Modal-Feature");
		if (modalFeature) {
			var currentFeatures = modal.element.getAttribute("data-modal") || "";
			modal.element.setAttribute("data-modal", currentFeatures + (currentFeatures ? " " : "") + modalFeature);
		}

		// Přidáváme nový obsah, emitujme proto událost "snippet ready".
		modal.element.trigger("snippetready", { parent: modal.element }, true);
	}).catch(function() {
		modal.element.classList.remove("sending-request");
		modal.innerHTML = "Při vyřizování požadavku došlo k chybě.";
	});
}


//
// Tady je náčrt případné funkcionality, kdy se může odkaz zobrazit v iframe v rámci modálního okna.
// Částečně to funguje, ale bylo by potřeba doladit (např. počítat a dynamicky nastavit velikost iframe atp.)
//

// Modal.openIframe = function(url) {
// 	var iframe = document.createElement("iframe");
// 	iframe.classList.add("modal-iframe");
// 	iframe.setAttribute("allow", "autoplay; fullscreen")
// 	iframe.setAttribute("allowfullscreen", "allowfullscreen");
// 	iframe.setAttribute("src", url);

// 	Modal.create(iframe);
// }

// document.addEventListener("click", function(event) {
// 	var target = event.target.matches("[data-modal='iframe']") ? event.target : event.target.closest("[data-modal='iframe']");
// 	if (!target) { return; }
// 	event.preventDefault();

// 	var href = target.getAttribute("href");
// 	Modal.openIframe(href);
// });



// *************************************************************************
// Události.
// *************************************************************************

//
// Přidá možnost označovat odkazy data atributem data-modal="ajax", kdy se výsledek
// AJAXu zobrazí v modálním okně.
//
document.addEventSelectorListener("click", "[data-modal='ajax'], [data-modal='ajax close']", function(event, target) {
	if (target.getAttribute("data-modal") == "ajax close") {
		event.preventDefault();
		Modal.get(target).close();
	}

	var href = target.getAttribute("href") || target.getAttribute("data-href");
	if (href) {
		event.preventDefault();
		ModalDialog.openAjax(href);
	}
});

//
// Uzavření modálního okna kliknutím na černé pozadí.
//
document.addEventMatchesListener("click", ".modal-dialog", function(event, target) {
	let modal = ModalDialog.get(target);
	if (!modal.isNoClose) {
		event.preventDefault();
		modal.close();
	}
});


// *************************************************************************
// Publikujeme do veřejného namespace.
// *************************************************************************

export default ModalDialog;
